/*
**************************************************************************
Title:          List filter
Created By:     Anshul Paliwal
Created on:     30/01/2021
Description:    List filter - filtering collumn label for search term
**************************************************************************
Created on:     15/02/2021
Description:    Tree filter - filtering collumn label for search term
**************************************************************************
*/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appFilter',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    // In case list is empty - this should not happen
    if (!items) {
      return [];
    }
    // no search term should show whole list
    if (!searchText) {
      return items;
    }

    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      // search term matching any text on lable collumn should be filtered
      return it.label.toLocaleLowerCase().includes(searchText);
    });
  }
}

@Pipe({
    name: 'treeFilter',
    standalone: false
})
export class treeFilterPipe implements PipeTransform {

  transform(filterItems: any[], searchText: string): any[] {

    if (!filterItems) {
      return [];
    }
    // no search term should show whole list
    if (!searchText) {
      return filterItems;
    }

    searchText = searchText.toLocaleLowerCase();
    const rus = itemFilter(searchText, filterItems.slice());

    function itemFilter(text, items){
      function copy(o){
        return Object.assign({}, o);
      }
      const r = items.map(copy).filter(it => {
        // search term matching any text on lable collumn should be filtered
        if (it.hasOwnProperty('children') && it.children.length > 0) {
          it.children = itemFilter( text, it.children.map(copy));
        }
        if (it.label.toLocaleLowerCase().includes(text) ||  (it.hasOwnProperty('children') && it.children.length > 0)){
          it.showChildren = true;
          return it.label;
        }
      });
      return r;
    }
    return rus;
  }

}
